import React, { useEffect, useState } from "react";
import Header from "./Header";
import { action, API, controller } from "../../../api/api";
import { useParams } from "react-router-dom";
import NotFound from "../../../layout/NotFound";
import { Model, UseForm } from "../../../hooks";
import { Paper } from "@mui/material";
import AccountsAndDetails from "./AccountsAndDetails";
import Items from "./Items";

const SellReturnForm = () => {
  const { invoiceId } = useParams();
  const { SellReturnMdl } = Model();
  const { values, setValues } = UseForm(SellReturnMdl);
  const [sellItems, setSellItems] = useState([]);
  const [sell, setSell] = useState({});

  const [loading, setLoading] = useState(false);
  const [dataNotFound, setDataNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    API(controller.Sell + action.GetById).getById(invoiceId, (res) => {
      if (res && res.status === 200 && res.result.id) {
        var val = res.result;
        var returnItems = val.sellItems
          .filter((j) => j.qty > 0)
          .map((i) => ({
            ...i,
            sellItemId: i.id,
            returnQty: "",
            isSellable: true,
            returnReason: 1,
            discAdj: "",
          }));
        setSellItems([...returnItems]);
        setValues((j) => ({
          ...j,
          customerId: val.customerId,
          customer: val.customer,
          sellId: val.id,
          outletId: val.outletId,
          orgId: val.orgId,
          returnDate: new Date().toISOString(),
          returnItems: returnItems,
          outlet: val.outlet,
        }));
        setSell({ ...val });
      } else setDataNotFound(true);
      setLoading(false);
    });
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? (
        <span className="text-gray-500 font-bold">Loading...</span>
      ) : (
        <div className="flex flex-col gap-3">
          {dataNotFound && (
            <NotFound msg="Invalid Invoice, Please check again." />
          )}

          {values && (
            <Paper className="flex flex-col gap-2 p-2">
              {/* Details Section */}
              <Header {...{ setSellItems, sellItems, values }} />

              {/* Return Items */}
              <Items {...{ setValues, sellItems, setSellItems }} />

              <AccountsAndDetails {...{ setValues, values, sell }} />
            </Paper>
          )}
        </div>
      )}
    </>
  );
};

export default SellReturnForm;
